import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FolderNode } from '@shared/layout/sidebar-menu/folder-menu/folder-menu.datasource';
import { ModalService } from '@shared/modal/modal.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'rav-folder-select',
  templateUrl: './folder-select.component.html',
  styleUrls: ['./folder-select.component.scss']
})
export class FolderSelectComponent implements OnInit {
  @Input() isCreateFolders = false;
  @Input() modalId: string;
  @Input() addInboxNode = false;
  @Input() foldersToDisable: string[] = [];
  @Output() folderChosen: EventEmitter<FolderNode> = new EventEmitter();

  selectedFolder: FolderNode;
  modalOpenSubscription: Subscription;
  modalCloseSubscription: Subscription;
  modalOpened = false;

  constructor(private modal: ModalService) {}

  ngOnInit() {
    this.modalOpenSubscription = this.modal.open.subscribe((data) => {
      if (data && data.modalId === this.modalId) this.modalOpened = true;
    });
    this.modalCloseSubscription = this.modal.close.subscribe((data) => {
      if (data && data.modalId === this.modalId) this.modalOpened = false;
    });
  }

  /**
   * Triggered by folder node click
   *
   * @param node the node that was selected
   */
  folderSelected(node: FolderNode) {
    this.selectedFolder = node;
  }

  /**
   * Triggered by the select button. Emits event for the selected folder to parent
   */
  select() {
    this.folderChosen.emit(this.selectedFolder);
    this.closeModal();
    if (this.isCreateFolders) this.modal.open.next({ modalId: this.createFoldersModalId });
  }

  /**
   * Closes the open modal
   */
  closeModal() {
    this.modal.close.next({ modalId: this.modalId, canceled: true });
  }

  /**
   * Since there are multiple create folder modals existing at once,
   * dynamically create modalId based upon which folder select menu is launched
   */
  get createFoldersModalId() {
    return this.modalId + 'NewFolder';
  }
}
